export default "__VITE_ASSET__d4435301__"